import useAuthStore from "@/stores/useAuthStore";
import { storeToRefs } from "pinia";
import { Router } from "vue-router";

const oauthRegex = /#access_token=.+/;

export default function (router: Router) {
  const authStore = useAuthStore();
  const {
    session,
  } = storeToRefs(authStore);

  router.beforeEach(async (to) => {
    if (!session.value) {
      await authStore.setSessionFromRoute(to);
    }

    if (to.hash.match(oauthRegex)) {
      return {
        ...to,
        hash: to.hash.replace(oauthRegex, ""),
      };
    }
  });
}
